import React, { useEffect, useState } from "react";
import useQuery from "../../utils/useQuery";
import { getSummary } from "../../services/summaryService";
import { isEmptyObj } from "../../utils/siteUtils";
import { initialLogic } from "../../services/productService";
import { isBizNull } from "../../utils";
import CheckoutErrorView from "../checkout-error-view/index";
import { selectUserState } from "../../selectors/application";
import { becomeAMemberSummary } from "../../redux/actions/becomeAMember";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { PropTypeCheckbox, PropTypePrimaryButton } from "../../prop-types";
import PreSalesCheckoutViewOnLine from "../presales-checkout-view-online";
import { getApiError } from "../../services/siteService";

const PreSalesCheckoutOnline = ({ fields: { hero, billingInfo, cardInfo, summary, newAddressLabel, delivery, defaultRedirect, confirmationUrl, payment, errors }, lang, becomeAMemberSummary, setBecomeAMemberSummary, user, history, page, match }) => {
  const [error, setError] = useState(null);
  const [showError, setShowError] = useState(false);
  const [payUrl, setPayUrl] = useState(null);
  const query = useQuery();
  const summaryData = getSummary(summary[0], becomeAMemberSummary);
  const [selectSummary, setSelectSummary] = useState(summaryData);
  const handleMessage = message => {
    switch (message.data.action) {
      case "redirect":
        global.location.href = message.data.payload;
    }
  };
  useEffect(() => {
    if (query.orderNo && query.code) {
      getApiError(query.code).then(error => {
        setError(error);
        setShowError(true);
      });
    }
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    //** Measurements */
    window.dataLayer = window.dataLayer || [];
    let _currency = "EUR";
    let _country = lang.indexOf("-") > -1 ? lang.split("-")[1] : "se";
    if (_country === "se") {
      _currency = "SEK";
    }
    let _page = {
      type: page.fields.pageType,
      currency: _currency,
      country: lang
    };
    // window.dataLayer.push({
    //   event: "virtualPageview",
    //   virtualPageUrl: history.location.pathname + history.location.search,
    //   virtualPageTitle: "pre_sales_checkout",
    //   page: _page
    // });
  }, []);

  useEffect(() => {
    let defaultRedirectHref = defaultRedirect?.value.href ? defaultRedirect.value.href : `/${lang}`;
    if (!becomeAMemberSummary || !becomeAMemberSummary?.color || isEmptyObj(becomeAMemberSummary?.color)) {
      history.replace(defaultRedirectHref);
    } else {
      initialLogic(lang, becomeAMemberSummary).then(payload => {
        if (!isBizNull(payload) && summary[0]) {
          selectSummary.images = payload.image;
          selectSummary.details.deposit.deposit.value = payload.formattedPrice;
          let selectSummary1 = JSON.parse(JSON.stringify(selectSummary));
          setSelectSummary(selectSummary1);
        }
      });
    }
  }, []);
  const onSummaryChangeCallback = ({ color, engine }) => {
    let data = {
      ...becomeAMemberSummary,
      engine: {
        ...becomeAMemberSummary.engine,
        ...engine
      },
      color: {
        ...becomeAMemberSummary.color,
        ...color
      }
    };
    initialLogic(lang, data).then(payload => {
      if (!isBizNull(payload) && summary[0]) {
        selectSummary.images = payload.image;
        selectSummary.details.deposit.deposit.value = payload.formattedPrice;
        let selectSummary1 = JSON.parse(JSON.stringify(selectSummary));
        setSelectSummary(selectSummary1);
        data.currency = payload.currency;
        data.deposit = payload.deposit;
        setBecomeAMemberSummary(data);
      }
    });
  };
  const onError = async ex => {
    const error = await getApiError(ex?.code);
    setError(error);
    setShowError(true);
  };
  const errorViewProps = {
    error,
    showError,
    onClose: () => {
      setShowError(false);
    }
  };
  return (
    <React.Fragment>
      {payUrl && <PaymentView {...{ ...payment, payUrl }} />}
      {!payUrl && (
        <React.Fragment>
          {error && <CheckoutErrorView {...errorViewProps} />}
          <PreSalesCheckoutViewOnLine
            {...{
              lang,
              hero: hero.fields,
              newAddressLabel,
              billingInfo,
              delivery,
              cardInfo: { ...cardInfo.fields },
              summary: summary[0] ? selectSummary : null,
              user,
              confirmationUrl,
              becomeAMemberSummary,
              onSummaryCallback: onSummaryChangeCallback,
              match: match,
              onPayment: (url, payMethodName) => {
                if (payMethodName === "IDeal") {
                  window.location.href = url;
                } else {
                  window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                  });
                  setPayUrl(url);
                }
              },
              onError: ex => onError(ex)
            }}
          />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
const PaymentView = ({ payment, payUrl }) => {
  const [iframeUrl, setIframeUrl] = useState(payUrl);
  useEffect(() => {
    setIframeUrl(payUrl);
  }, [payUrl]);
  return (
    <section className="pre-sales-checkout grid">
      <div className="iframe-grid-block">{<iframe src={iframeUrl} title="pre-sales checkout" />}</div>
    </section>
  );
};

const mapStateToProps = state => ({
  user: selectUserState(state),
  becomeAMemberSummary: state.becomeAMemberSummary
});
const mapDispatchToProps = dispatch => ({
  setBecomeAMemberSummary: data => {
    dispatch(becomeAMemberSummary(data));
  }
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PreSalesCheckoutOnline));

PreSalesCheckoutOnline.propTypes = {
  view: PropTypes.string,
  hero: PropTypes.shape({
    heading: PropTypes.shape({
      type: PropTypes.string,
      className: PropTypes.string,
      /** This takes the component is RTF */
      html: PropTypes.string
    })
  }),
  billingInfo: PropTypes.shape({
    heading: PropTypes.shape({
      type: PropTypes.string,
      className: PropTypes.string,
      /** This takes the component is RTF */
      html: PropTypes.string
    }),
    firstName: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    lastName: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    email: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    phoneCountryCode: PropTypes.shape({
      className: PropTypes.string,
      options: PropTypes.arrayOf(
        PropTypes.shape({
          value: PropTypes.string.isRequired,
          code: PropTypes.string.isRequired
        })
      ),
      stackDirection: PropTypes.oneOf(["horisontal", "vertical"]),
      selectedOption: PropTypes.object,
      placeholder: PropTypes.string,
      onChange: PropTypes.func
    }),
    phoneNumber: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    address1: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    address2: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    zipCode: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    city: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    country: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    })
  }),
  cardInfo: PropTypes.shape({
    heading: PropTypes.shape({
      type: PropTypes.string,
      className: PropTypes.string,
      /** This takes the component is RTF */
      html: PropTypes.string
    }),
    subHeading: PropTypes.shape({
      type: PropTypes.string,
      className: PropTypes.string,
      /** This takes the component is RTF */
      html: PropTypes.string
    }),
    cardIcons: PropTypes.array,
    cardHolderName: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    cardNumber: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    cardExpiryDate: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    cardCVC: PropTypes.shape({
      pattern: PropTypes.string,
      infoMessage: PropTypes.string,
      warningMessage: PropTypes.string,
      value: PropTypes.string,
      type: PropTypes.string,
      onBlur: PropTypes.func,
      onChange: PropTypes.func,
      onFocus: PropTypes.func,
      hasError: PropTypes.bool
    }),
    termsCheckbox: PropTypeCheckbox,
    paymentInfoCheckbox: PropTypeCheckbox,
    submit: PropTypePrimaryButton
  }),
  summary: PropTypes.shape({
    heading: PropTypes.object
  }),
  payment: PropTypes.any,
  error: PropTypes.any
};
